import config from "@/config";

export default function useAdditionalSources() {
  const loadSource = (url: string) => {
    const tag = document.createElement("script");
    tag.src = url;
    tag.setAttribute("async", "");
    const fjs = document.getElementsByTagName("script")[0];
    fjs.parentNode && fjs.parentNode.insertBefore(tag, fjs);
  };

  const init = () => {
    const source = [];

    if (config.delightVideoPlayerLicense)
      source.push(`//cdn.delight-vr.com/latest/dl8-${config.delightVideoPlayerLicense}.js`);

    source.forEach(i => loadSource(i));
  };

  return {
    init,
  };
}
